import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const RevenueIntelligence = lazy(() => import('../components/RevenueIntelligence'));
const AudienceExplorer = lazy(() => import('../components/AudienceExplorer/AudienceExplorer'));

const revenueIntelligenceRoute: RouteObject = {
  path: 'intelligence',
  element: <RevenueIntelligence />,
};

export const audienceExplorerRoute: RouteObject = {
  path: 'audiences/:cohortId',
  element: <AudienceExplorer />,
};

export default revenueIntelligenceRoute;
